import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
} from "@chakra-ui/react";

const EmailPreviewModal = ({ emailBody, isOpen, onClose }) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="5xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent maxH="90vh">
          <ModalHeader>Email Preview</ModalHeader>
          <ModalCloseButton />
          <ModalBody p={0}>
            <Box dangerouslySetInnerHTML={{ __html: emailBody }} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default EmailPreviewModal;
